export default __webpack_public_path__ + "static/media/pyramid.4152fd57.png";